export default __webpack_public_path__ + "static/media/ic_martinique.b1cbb10c.svg";